import { ReactElement, useState, useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { CheckboxInputAccessible } from '@components';
import { iNominationFormValues } from '@services/NominationService';

function NominationStep13(): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { values, setFieldValue }: { values: iNominationFormValues; setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void } = useFormikContext<iNominationFormValues>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const [declarationMsg, setDeclarationMsg] = useState(<div>Unpopulated</div>);

  const individualRoadOffence: ReactElement = (
    <div>
      <p>I understand that it is an offence under the <i>Road Safety Act 1986</i> (which may carry a fine in excess of $11,000 and potential licence loss for an individual, or a fine in excess of $22,000 for a body corporate) to knowingly provide false or misleading information in a nomination statement.</p>
      <p>I understand that I may be served with a summons to appear and give evidence in court in relation to this nomination.</p>
      <p>I declare that the information that I have supplied in the form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
    </div>
  );
  const companyRoadOffence: ReactElement = (
    <div>
      <p>I understand that it is an offence under the <i>Road Safety Act 1986</i> (which may carry a fine in excess of $11,000 and potential licence loss for an individual, or a fine in excess of $22,000 for a body corporate) to knowingly provide false or misleading information in a nomination statement.</p>
      <p>I understand that I may be served with a summons to appear and give evidence in court in relation to this nomination.</p>
      <p>I declare that I am giving this information and signing this statement as a person authorised by the company to do so.</p>
      <p>I declare that the information that I have supplied in the form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
    </div>
  );
  const individualMarineOffence: ReactElement = (
    <div>
      <p>I understand that it is an offence under the <i>Marine Safety Act 2010</i> (which may carry a fine in excess of $11,000) to knowingly provide false or misleading information in a nomination statement.</p>
      <p>I understand that I may be served with a summons to give evidence in court in relation to this nomination.</p>
      <p>I declare that the information that I have supplied in the form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
    </div>
  );
  const companyMarineOffence: ReactElement = (
    <div>
      <p>I understand that it is an offence under the <i>Marine Safety Act 2010</i> (which may carry a fine in excess of $11,000) to knowingly provide false or misleading information in a nomination statement.</p>
      <p>I understand that I may be served with a summons to give evidence in court in relation to this nomination.</p>
      <p>I declare that I am giving this information and signing this statement as a person authorised by the company to do so.</p>
      <p>I declare that the information that I have supplied in the form, and any attachments to this form, are true and correct to the best of my knowledge.</p>
    </div>
  );

  useEffect(() => {
    let message: React.ReactElement | null = null;

    if (values.isDebtorTypeIndividual) {
      message = values.IsMarineOffence ? individualMarineOffence : individualRoadOffence;
    } else {
      message = values.IsMarineOffence ? companyMarineOffence : companyRoadOffence;
    }

    setDeclarationMsg(message);
  }, []);

  return (
    <>
      {!loading && (
        <>
          <div className="vfH2">Declaration</div>
          <div>{declarationMsg}</div>
          <Field
            name="nominationConsentToDeclaration"
            component={CheckboxInputAccessible}
            title="I agree to the statements above"
          />
        </>
      )}
    </>
  );
}

export default NominationStep13;
